
import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import PaymentMethodPageLayer from "../components/PaymentMethodPageLayer";
// import FormPageLayer from "../components/FormPageLayer";



const PaymentMentPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Payment method Form" header="Payment Method" />

        {/* FormPageLayer */}
        <PaymentMethodPageLayer />


      </MasterLayout>

    </>
  );
};

export default PaymentMentPage;
